// hack to propagate change event on the input
// https://stackoverflow.com/a/46012210/221213
export const sendInputEvent = (target, value = '') => {
    var _a;
    const inputProtoType = window.HTMLInputElement.prototype;
    const setter = (_a = Object.getOwnPropertyDescriptor(inputProtoType, 'value')) === null || _a === void 0 ? void 0 : _a.set;
    setter === null || setter === void 0 ? void 0 : setter.call(target, value);
    const event = new Event('input', { bubbles: true });
    target.dispatchEvent(event);
    target.blur();
};
//# sourceMappingURL=sendInputEvent.js.map